import { render, staticRenderFns } from "./beneficiary-modify.vue?vue&type=template&id=e3dc9276&"
import script from "./beneficiary-modify.vue?vue&type=script&lang=js&"
export * from "./beneficiary-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports